export default function Logout() {
    return {
        type: "LOGOUT",
    }
}
